export const SET_FORM_DATA = "SET_FORM_DATA";
export const FIELD_VALUE_CHANGED = "FIELD_VALUE_CHANGED";
export const SET_FIELDS_ERRORS = "SET_FIELDS_ERRORS";
export const SET_DRAFT_VALUES = "SET_DRAFT_VALUES";
export const SET_TRANSLATES = "SET_TRANSLATES";
